import { render, staticRenderFns } from "./HoldingsManagementView.vue?vue&type=template&id=750e39a7&scoped=true&"
import script from "./HoldingsManagementView.vue?vue&type=script&lang=js&"
export * from "./HoldingsManagementView.vue?vue&type=script&lang=js&"
import style0 from "./HoldingsManagementView.vue?vue&type=style&index=0&id=750e39a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e39a7",
  null
  
)

export default component.exports